import React, { Component } from 'react';
import Range_picker_vd from '../components/Range_picker_vd';
import Chart_vd_cal from '../components/Chart_vd';
import Chart_vd_step from '../components/Chart_vd_step';
import Chart_vd_dis from '../components/Chart_vd_dis';
import Chart_vd_floors from '../components/Chart_vd_floors';
import Chart_vd_pm from '../components/Chart_vd_pm';
import Chart_vd_temp from '../components/Chart_vd_temp';
import Chart_vd_hum from '../components/Chart_vd_hum';
import Chart_vd_hr from '../components/Chart_vd_hr';
import Chart_vd_sleep from '../components/Chart_vd_sleep'
import Chart_garmin_step from '../components/Chart_garmin_step';
import Chart_garmin_dis from '../components/Chart_garmin_dis';
import Chart_garmin_floor from '../components/Chart_garmin_floor';
import Chart_garmin_hr from '../components/Chart_garmin_hr';
import Chart_garmin_sleep from '../components/Chart_garmin_sleep';
import Chart_garmin_stress from '../components/Chart_garmin_stress';

export default class Visualdash extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_fitbit: [],
      data_garmin: [],
      data_airbox: [],
      data_hr: [],
      data_sleep: {
        'rem': [],
        'light': [],
        'deep': [],
        'wake': []
      }
    };
    this.changedate = this.changedate.bind(this);
  }
  async changedate(value) {
    await this.setState({ date: value });
    const id = this.props.id;
    if (value[0] == "") {
      this.setState({
        data_fitbit: [],
        data_garmin: [],
        data_airbox: [],
        data_hr: [],
        data_sleep: {
          'light': [],
          'rem': [],
          'deep': [],
          'wake': []
        }
      });
    } else {
      try {
        const result = await fetch(
          `/api/getUserFitbitByRange?id=${id}&start=${value[0]}&end=${value[1]}`,
          {
            mode: "cors",
            method: "GET"
          }
        );

        const data_fitbit = await result.json();
        console.log('Fitbit data :', data_fitbit);
        // error handling
        this.setState({ data_fitbit });
        // this.generateCSV(data);
      } catch (err) {
        console.log(err);
      }
      try {
        const result = await fetch(
          `/api/getUserGarminByRange?id=${id}&start=${value[0]}&end=${value[1]}`,
          {
            mode: "cors",
            method: "GET"
          }
        );

        const data_garmin = await result.json();
        console.log('Garmin data :', data_garmin);
        this.setState({ data_garmin });
      } catch (err) {
        console.log(err);
      }
      try {
        const result_spo2 = await fetch(
          `/api/getGarminSleepSpo2?id=${id}&start=${value[0]}&end=${value[1]}`,
          {
            mode: "cors",
            method: "GET"
          }
        );
        const data_spo2 = await result_spo2.json();
        console.log('test spo2 :', data_spo2);
      } catch (e) {
        console.log(e);
      }
      try {
        const result_test = await fetch(
          `/api/getGarminHeartRate?id=${id}&start=${value[0]}&end=${value[1]}`,
          {
            mode: "cors",
            method: "GET"
          }
        );
        const data_test = await result_test.json();
        console.log('test data :', data_test);
      } catch (e) {
        console.log(e);
      }


      try {
        const result_hr = await fetch(
          `/api/getHeartRateMeanByRange?id=${id}&start=${value[0]}&end=${value[1]}`,
          {
            mode: "cors",
            method: "GET"
          }
        );

        const data_hr = await result_hr.json();
        console.log('hr data :', data_hr);
        this.setState({ data_hr });

      } catch (err) {
        console.log(err);
      }
      try {
        const result_sleep = await fetch(
          `/api/getSumSleepByRange?id=${id}&start=${value[0]}&end=${value[1]}`,
          {
            mode: "cors",
            method: "GET"
          }
        );

        const data_sleep = await result_sleep.json();
        console.log('sleep data :', data_sleep);
        this.setState({ data_sleep });

      } catch (err) {
        console.log(err);
      }
      try {
        const result_airbox = await fetch(
          `/api/getUserAirboxByRange?id=${id}&start=${value[0]}&end=${value[1]}`,
          {
            mode: "cors",
            method: "GET"
          }
        );

        const data_airbox = await result_airbox.json();
        console.log('airbox data :', data_airbox);
        // error handling
        this.setState({ data_airbox });
        // this.generateCSV(data);
      } catch (err) {
        console.log(err);
      }
    }
  }
  render() {
    return (
      <div className="visualdash">
        <div className="header-vd" style={{marginTop: 50}}>
          <h2>Visualization</h2>
        </div>
        <Range_picker_vd change={this.changedate} />
        <div>
          {(this.state.data_fitbit.length != 0) && <div className="graph_container"><Chart_vd_cal data={this.state.data_fitbit} date={this.state.date} /></div>}
          {(this.state.data_fitbit.length != 0) && <div className="graph_container"><Chart_vd_dis data={this.state.data_fitbit} date={this.state.date} /></div>}
          {(this.state.data_fitbit.length != 0) && <div className="graph_container"><Chart_vd_floors data={this.state.data_fitbit} date={this.state.date} /></div>}
          {(this.state.data_fitbit.length != 0) && <div className="graph_container"><Chart_vd_step data={this.state.data_fitbit} date={this.state.date} /></div>}
          {(this.state.data_garmin.length != 0) && <div className="graph_container"><Chart_garmin_step data={this.state.data_garmin} date={this.state.date} /></div>}
          {(this.state.data_garmin.length != 0) && <div className="graph_container"><Chart_garmin_dis data={this.state.data_garmin} date={this.state.date} /></div>}
          {(this.state.data_garmin.length != 0) && <div className="graph_container"><Chart_garmin_floor data={this.state.data_garmin} date={this.state.date} /></div>}
          {(this.state.data_garmin.length != 0) && <div className="graph_container"><Chart_garmin_hr data={this.state.data_garmin} date={this.state.date} /></div>}
          {(this.state.data_garmin.length != 0) && <div className="graph_container"><Chart_garmin_stress data={this.state.data_garmin} date={this.state.date} /></div>}
          {(this.state.data_garmin.length != 0) && <div className="graph_container"><Chart_garmin_sleep data={this.state.data_garmin} date={this.state.date} /></div>}
          {(this.state.data_airbox.length != 0) && <div className="graph_container"><Chart_vd_pm data={this.state.data_airbox} date={this.state.date} /></div>}
          {(this.state.data_airbox.length != 0) && <div className="graph_container"><Chart_vd_temp data={this.state.data_airbox} date={this.state.date} /></div>}
          {(this.state.data_airbox.length != 0) && <div className="graph_container"><Chart_vd_hum data={this.state.data_airbox} date={this.state.date} /></div>}
          {(this.state.data_hr.length != 0) && <div className="graph_container"><Chart_vd_hr data={this.state.data_hr} date={this.state.date} /></div>}
          {(this.state.data_sleep.wake.length != 0 || this.state.data_sleep.light.length != 0 || this.state.data_sleep.deep.length != 0 || this.state.data_sleep.rem.length != 0) && <div className="graph_container"><Chart_vd_sleep data={this.state.data_sleep} date={this.state.date} /></div>}
        </div>
      </div>
    );
  }
}
